import { Injectable } from '@angular/core';

import { PcvizProject, PcvizSectionLayerView } from '@mirage-projects/cw-models';

/**
 * Centralizes core section module logic
 */
@Injectable({ providedIn: 'root' })
export class SectionPcvizService {
    createSectionLayerView(pcvizProject: PcvizProject): PcvizSectionLayerView {
        return new PointCloudViz.Section.SectionLayerView(pcvizProject);
    }
}
